import React from "react";
import { useApp } from "context";
import { Form } from "components";
import { LogoBrand } from "assets/images";

export const ResetPassword = () => {
  const { t, theme } = useApp();

  const rules = t.message.auth.password_rule;

  return (
    <div className="qh-feedback">
      <div className="qh-wrapper">
        <LogoBrand />
        <div className="qh-header" style={{ color: theme.palette.font.color }}>
          <div className="title">{t.title.auth.reset_password}</div>
          <div className="description">{t.message.auth.reset_password}</div>
          <ul className="list">
            {rules.map((item: string, i: number) => {
              return (
                <li
                  key={i}
                  style={{
                    fontSize: theme.font.md,
                    color: theme.palette.font.color,
                  }}
                >
                  {item}
                </li>
              );
            })}
          </ul>
        </div>
        <div className="qh-content">
          <Form.ResetPassword />
        </div>
      </div>
    </div>
  );
};
